export default __webpack_public_path__ + "static/media/mail_act.d8c841d5.svg";